import { IAppendParameterToUrl } from './types'

export const appendParameterToUrl = (params: Array<IAppendParameterToUrl>): string => {
  const urlObject = new URL(window.location.href)

  params.forEach(parameter => urlObject.searchParams.append(parameter.key, parameter.value))

  return urlObject.href
}
